import React, { forwardRef } from 'react';
import { useLogout } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';
import ExitIcon from '@material-ui/icons/PowerSettingsNew';

const MyLogoutButton = forwardRef((props, ref) => {
  const logout = useLogout();
  const handleClick = () => logout();
  return (
    <MenuItem
      onClick={handleClick}
      ref={ref}
    >
      <ExitIcon /> <span style={{ paddingLeft: 10 }}>Logout</span>
    </MenuItem>
  );
});

export default MyLogoutButton;